import type { CanvasScope } from '@/features/studio/lib/canvas-scope'

/** AI payload `_silk_studio` — 3b 项目内扣项目池/派工额度，不扣个人账户。自由创作不要传项目 id。 */
export function buildStudioAIBillingPayload(
  productionPublicId: string,
  scope?: Pick<CanvasScope, 'scopeType' | 'scopeKey'>,
): Record<string, unknown> {
  const billing: Record<string, string> = {
    production_public_id: productionPublicId,
  }
  if (scope && scope.scopeType !== 'production') {
    billing.item_type = scope.scopeType
    billing.item_public_id = scope.scopeKey
  }
  return { _silk_studio: billing }
}

export function mergeStudioAIBillingPayload(
  productionPublicId: string | undefined,
  payload: Record<string, unknown> | undefined,
  scope?: Pick<CanvasScope, 'scopeType' | 'scopeKey'>,
): Record<string, unknown> {
  const base = { ...(payload ?? {}) }
  const pid = productionPublicId?.trim()
  if (!pid) return base
  return {
    ...base,
    ...buildStudioAIBillingPayload(pid, scope),
  }
}
